export class TempQuote {
    componentOnGoing: any;
    componentProjectType: any;
    componentProjectInvolvement: any;
    componentMaterialDamaged: any;
    componentLiability: any;
    componentEnhanceYourCover: any;
    dyd4Flag = false;
}
